import { Component, OnInit } from '@angular/core';
import { Service } from '../service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { IQuestions } from '../questions'

@Component({
  selector: 'app-answer',
  templateUrl: './answer.component.html',
  styleUrls: ['./answer.component.scss']
})
export class AnswerComponent implements OnInit {
  advisor;
  public isCollapsed = false;
  isShown: boolean = false;
  quizResponse: string;
  answerIcon: boolean = true;
  toogleIcon: string = '+';
  connectWithAdvisor: string = 'Connect with your Financial Advisor';
  backgroundImg = "../../assets/mom_and_child.jpg";
  name: string = '';
  questions: any;
  question: any;
  summary = [];
  logo: string;
  questionTitle: any;
  answerTitle: any;
  connectBtn: any;
  restartBtn: any;
  viewList: any;
  advisorsList = [];
  advisors;
  multiLang: any;

  constructor(
    public quiz: Service,
    private route: ActivatedRoute,
    public router: Router,
    public translate: TranslateService,

  ) {
    this.quiz.changeLang(this.translate.currentLang);
    this.changeLang(this.translate.currentLang);
    this.getAdvisors();
  }


  //toogle dropdown window for answers
  toggle() {
    this.isShown = !this.isShown;

    if (this.isShown) {
      this.toogleIcon = '-';

    }
    else {
      this.toogleIcon = '+';
    }
  }

  ngOnInit(): void {
  }

  getAdvisors(): void {
    this.quiz.getAdvisors()
      .subscribe(advisor => {
        this.advisors = advisor;
        this.getAdvisor();

      });

  }
  getAdvisor() {
    this.advisor = this.advisors;

    const name = this.route.snapshot.paramMap.get('name');

    //loop through questions
    for (var i = 0; i < this.advisor?.advisor.length; i++) {
      this.advisorsList[i] = this.advisor.advisor[i];
    }

    this.advisor = this.advisorsList.filter(
      x => x.name === name);
      this.multiLang = this.advisor[0].MultiLang;

  }


  changeLang(lang: string) {
    this.quiz.changeLang(lang);

      //Subscrbe to getQuestions() - Go to Service.ts
      this.quiz.getQuestions()
        .subscribe(questionsData => {
          this.questions = questionsData;
          this.logo = this.questions.homePage[0].FRLOGO;

          // Call Sort message to pass this.questions value
          this.sortQuestions();

        });

  }

  //Filter through this.questionsList and match is match it with questions ID 
  sortQuestions() {
    this.questionTitle = this.questions.SUMMARYPAGE[0].QUESTIONTITLE;
    this.answerTitle = this.questions.SUMMARYPAGE[0].ANSWERTITLE;
    this.connectBtn = this.questions.SUMMARYPAGE[0].CONNECTBTN;
    this.restartBtn = this.questions.SUMMARYPAGE[0].RESTARTBTN;
    this.viewList = this.questions.SUMMARYPAGE[0].VIEWQUESTIONS;

    //Check if answers contain No, if it does then change the response
    for (let answer of this.quiz.answers) {
      if (answer.answer === "No" || answer.answer === "Non") {
        
        this.quizResponse = this.questions.SUMMARYPAGE[0].NOSUMMARY;
        this.answerIcon = false;
        this.connectWithAdvisor = 'Visit www.ipcc.ca for more information.';
        this.backgroundImg = "../../assets/answers_No.jpg";
      }
      else {
        this.quizResponse = this.questions.SUMMARYPAGE[0].YESSUMMARY;

      }
    }
  }


}